export enum USER_ACTION_TYPES {
  REQUEST = 'USER_FETCH_REQUEST',
  SUCCESS = 'USER_FETCH_SUCCESS',
  UPDATE_REQUEST = 'USER_UPDATE_REQUEST',
  UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS',
  UPDATE_FAILURE = 'USER_UPDATE_FAILURE',
}

export type UserActionPayload = {
  id?: number;
  cookies?: string;
  error?: { [flow: string]: { errorMessage: string } };
  [key: string]: unknown;
};

export const fetchUser = (payload: UserActionPayload) => ({
  type: USER_ACTION_TYPES.REQUEST,
  payload,
});

export const fetchUserSuccess = (payload: UserActionPayload) => ({
  type: USER_ACTION_TYPES.SUCCESS,
  payload,
});

export const updateUser = (payload: UserActionPayload) => ({
  type: USER_ACTION_TYPES.UPDATE_REQUEST,
  payload,
});

export const updateUserFailed = (payload: UserActionPayload) => ({
  type: USER_ACTION_TYPES.UPDATE_FAILURE,
  payload,
});

export const updateUserSuccess = (payload: UserActionPayload) => ({
  type: USER_ACTION_TYPES.UPDATE_SUCCESS,
  payload,
});
